import { render } from "./realNameDetail.vue?vue&type=template&id=5cd1610e&scoped=true"
import script from "./realNameDetail.vue?vue&type=script&lang=js"
export * from "./realNameDetail.vue?vue&type=script&lang=js"

import "./realNameDetail.vue?vue&type=style&index=0&id=5cd1610e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd1610e"]])

export default __exports__